/** LinkedIn admin resources. */
export default [

  {
    path: '/linkedin',
    name: 'LinkedIn',
    component: () => import('@/views/private/linkedin/LinkedinView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn',
    },
  },

  {
    path: '/linkedin-profiles',
    name: 'LinkedIn Profiles',
    component: () => import('@/views/private/linkedin/LinkedinProfilesView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Profiles',
    },
  },

  {
    path: '/linkedin-conversations',
    name: 'LinkedIn Conversations',
    component: () => import('@/views/private/linkedin/LinkedinConversationsView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Conversations',
    },
  },

  {
    path: '/linkedin-conversation/:conversationId',
    name: 'LinkedIn Conversation',
    component: () => import('@/views/private/linkedin/LinkedinConversationView.vue'),
    props: function(route) {
      return {
        conversationId: Number(route.params.conversationId),
      };
    },
    meta: {
      public: false,
      title: 'LinkedIn Conversation',
    },
  },

  {
    path: '/linkedin-connections',
    name: 'LinkedIn Connections',
    component: () => import('@/views/private/linkedin/LinkedinConnectionsView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Connections',
    },
  },

  {
    path: '/linkedin-invitations-received',
    name: 'LinkedIn Invitations Received',
    component: () => import('@/views/private/linkedin/LinkedinInvitationsReceivedView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Invitations Received',
    },
  },

  {
    path: '/linkedin-invitations-sent',
    name: 'LinkedIn Invitations Sent',
    component: () => import('@/views/private/linkedin/LinkedinInvitationsSentView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Invitations Sent',
    },
  },

  {
    path: '/linkedin-suggestions',
    name: 'LinkedIn Suggestions',
    component: () => import('@/views/private/linkedin/LinkedinSuggestionsView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Suggestions',
    },
  },

  {
    path: '/linkedin-views',
    name: 'LinkedIn Views',
    component: () => import('@/views/private/linkedin/LinkedinViewsView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Views',
    },
  },

  {
    path: '/linkedin-searches',
    name: 'LinkedIn Searches',
    component: () => import('@/views/private/linkedin/LinkedinSearchesView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Searches',
    },
  },

  {
    path: '/linkedin-personas',
    name: 'LinkedIn Personas',
    component: () => import('@/views/private/linkedin/LinkedinPersonasView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Personas',
    },
  },

  {
    path: '/linkedin-priority-companies',
    name: 'LinkedIn Priority Companies',
    component: () => import('@/views/private/linkedin/LinkedinPriorityCompaniesView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Priority Companies',
    },
  },

  {
    path: '/linkedin-search/:searchId',
    name: 'LinkedIn Search',
    component: () => import('@/views/private/linkedin/LinkedinSearchView.vue'),
    props: function(route) {
      return {
        searchId: Number(route.params.searchId),
      };
    },
    meta: {
      public: false,
      title: 'LinkedIn Searches',
    },
  },

  {
    path: '/linkedin-groups',
    name: 'LinkedIn Groups',
    component: () => import('@/views/private/linkedin/LinkedinGroupsView.vue'),
    meta: {
      public: false,
      title: 'LinkedIn Groups',
    },
  },

  {
    path: '/linkedin-group/:linkedinGroupId',
    name: 'LinkedIn Group',
    component: () => import('@/views/private/linkedin/LinkedinGroupView.vue'),
    props: function(route) {
      return {
        linkedinGroupId: Number(route.params.linkedinGroupId),
      };
    },
    meta: {
      public: false,
      title: 'LinkedIn Group',
    },
  },

];
